import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Home/Homepage.css";
import "../Trading/CurrencyPairManagementPage.css";
import "../Trading/AllOpenOrdersPage.css";

const STATIC_STAKES = [
  { _id: "st1", user_id: "user_101", packageName: "ETH Staking 30D", coin: "ETH", amount: 10, apy: 5, lockDays: 30, status: "Active", startDate: "2025-02-01T10:00:00.000Z", endDate: "2025-03-03T10:00:00.000Z", rewardsEarned: 0.41 },
  { _id: "st2", user_id: "user_202", packageName: "BTC Staking 90D", coin: "BTC", amount: 0.5, apy: 4.5, lockDays: 90, status: "Active", startDate: "2025-01-20T08:30:00.000Z", endDate: "2025-04-20T08:30:00.000Z", rewardsEarned: 0.006 },
  { _id: "st3", user_id: "user_303", packageName: "USDT Flexible", coin: "USDT", amount: 5000, apy: 3, lockDays: 0, status: "Active", startDate: "2025-02-10T12:00:00.000Z", endDate: null, rewardsEarned: 4.11 },
  { _id: "st4", user_id: "user_101", packageName: "BNB Lock 60D", coin: "BNB", amount: 50, apy: 6, lockDays: 60, status: "Active", startDate: "2025-02-05T14:00:00.000Z", endDate: "2025-04-06T14:00:00.000Z", rewardsEarned: 0.49 },
  { _id: "st5", user_id: "user_404", packageName: "ETH Staking 30D", coin: "ETH", amount: 25, apy: 5, lockDays: 30, status: "Completed", startDate: "2025-01-01T00:00:00.000Z", endDate: "2025-02-01T00:00:00.000Z", rewardsEarned: 1.03 },
  { _id: "st6", user_id: "user_202", packageName: "XRP 90D Lock", coin: "XRP", amount: 10000, apy: 4, lockDays: 90, status: "Active", startDate: "2025-02-12T09:00:00.000Z", endDate: "2025-05-13T09:00:00.000Z", rewardsEarned: 0 },
];

const StakingStakesPage = () => {
  const [stakes] = useState(STATIC_STAKES);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const formatDate = (iso) => {
    if (!iso) return "—";
    try {
      const d = new Date(iso);
      return d.toLocaleString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
    } catch {
      return iso;
    }
  };

  const formatNum = (n) => (n != null && !Number.isNaN(Number(n)) ? Number(n).toLocaleString("en-IN", { maximumFractionDigits: 8 }) : "—");

  const filtered = stakes.filter(
    (s) =>
      (s.user_id?.toLowerCase().includes(search.toLowerCase()) ||
        s.packageName?.toLowerCase().includes(search.toLowerCase()) ||
        s.coin?.toLowerCase().includes(search.toLowerCase())) &&
      (!statusFilter || s.status === statusFilter)
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Staking</span>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>User Stakes</span>
          </p>
          <h1 className="dashboard-hero__title">User Stakes</h1>
          <p className="dashboard-hero__subtitle">View and manage all user staking positions</p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-coins" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="openorders-section">
          <div className="openorders-section__header">
            <div className="openorders-section__title-wrap">
              <span className="openorders-section__icon">
                <i className="fas fa-coins" />
              </span>
              <h2 className="openorders-section__title">Staking Positions</h2>
            </div>
            <div className="openorders-section__stats">
              <span className="openorders-stat"><strong>{stakes.length}</strong> Total</span>
            </div>
          </div>
          <div style={{ display: "flex", gap: "1rem", padding: "0.75rem 1.5rem", background: "#f8fafc", borderBottom: "1px solid var(--border)" }}>
            <div className="openorders-search-wrap" style={{ flex: 1, margin: 0, padding: 0 }}>
              <i className="fas fa-search" />
              <input
                type="text"
                placeholder="Search by user ID, package or coin..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="openorders-search-input"
              />
            </div>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{ padding: "0.5rem 1rem", borderRadius: 8, border: "1px solid var(--border)" }}
            >
              <option value="">All Status</option>
              <option value="Active">Active</option>
              <option value="Completed">Completed</option>
            </select>
          </div>
          <div className="openorders-table-wrap">
            <table className="openorders-table">
              <thead>
                <tr>
                  <th>User ID</th>
                  <th>Package</th>
                  <th>Coin</th>
                  <th>Amount</th>
                  <th>APY</th>
                  <th>Lock</th>
                  <th>Rewards Earned</th>
                  <th>Status</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((row) => (
                  <tr key={row._id}>
                    <td><span className="openorders-order-id">{row.user_id}</span></td>
                    <td><strong>{row.packageName}</strong></td>
                    <td>{row.coin}</td>
                    <td>{formatNum(row.amount)}</td>
                    <td>{row.apy}%</td>
                    <td>{row.lockDays === 0 ? "Flexible" : `${row.lockDays}d`}</td>
                    <td>{formatNum(row.rewardsEarned)} {row.coin}</td>
                    <td>
                      <span className={`cp-badge cp-badge--${row.status === "Active" ? "global" : "local"}`} style={{ fontSize: "0.75rem" }}>
                        {row.status}
                      </span>
                    </td>
                    <td>{formatDate(row.startDate)}</td>
                    <td>{formatDate(row.endDate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filtered.length === 0 && (
            <p className="openorders-empty">No stakes match your search.</p>
          )}
        </section>
      </div>
    </main>
  );
};

export default StakingStakesPage;
